import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { groundTransportSections } from "groundTransport/groundTransportSections";
import { useGroundTransportDetail } from "groundTransport/useGroundTransportDetail";
import React from "react";
import { SidePanelLinkedShowList } from "../SidePanelLinkedShowList";
import { invalidateGroundTransportsCache } from "utilities/api/groundTransportQuery";
import { useQueryClient } from "@tanstack/react-query";
interface GroundSidePanelDetailsProps {
  groundTransportSidePanelData: server.dto.GroundTransportSidePanelData
}

export const GroundSidePanelDetails = (props: GroundSidePanelDetailsProps) => {
  const {
    state,
    hasDriver,
    hasMap,
    onValueChanged,
    onSuccessfulUpdate,
    getUpdateGroundTransportInstruction,
  } = useGroundTransportDetail(
    props.groundTransportSidePanelData.groundTransport,
    props.groundTransportSidePanelData.passengers,
    () => { },
    () => { },
    () => { }
  );

  const queryClient = useQueryClient();

  const onSuccessfulUpdateSidePanel = async (key: string, value: any) => {
    await onSuccessfulUpdate(key, value);
    invalidateGroundTransportsCache(queryClient);
  }

  const sections = groundTransportSections(state, props.groundTransportSidePanelData.linkedShows, getUpdateGroundTransportInstruction, hasDriver, hasMap);

  return <SidePanelDetailSectionTemplate
    isInPageEditable={props.groundTransportSidePanelData.groundTransport.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateSidePanel}
    fields={sections}
    additionalContent={<>
      <SidePanelLinkedShowList linkedShows={props.groundTransportSidePanelData.linkedShows} />
    </>}
  />
}